import { render, staticRenderFns } from "./CheckpointDialog.vue?vue&type=template&id=54a0f08c&"
import script from "./CheckpointDialog.vue?vue&type=script&lang=js&"
export * from "./CheckpointDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports